module.exports = __webpack_public_path__ + "static/img/20018 (2).7731da7.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20018 (2).webp
// module id = 3jZx
// module chunks = 14